import { render, staticRenderFns } from "./Palette.vue?vue&type=template&id=39fb0e76&scoped=true"
import script from "./Palette.vue?vue&type=script&lang=ts"
export * from "./Palette.vue?vue&type=script&lang=ts"
import style0 from "./Palette.vue?vue&type=style&index=0&id=39fb0e76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fb0e76",
  null
  
)

export default component.exports